import React, {Component} from 'react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';





import {Row, Col} from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';
import {TableFooter} from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';
import RaisedButton from 'material-ui/RaisedButton';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchListMasterParam } from '../../actions/info/listmaster_info_form';

const style = {
        margin: 20,
        float: 'right'
    },
    stylePaper = {
        marginTop: 20,
        marginBottom: 20
    },
    styleTable = {
        margin: 'auto',
        width: '90%'
    },
    styleButton = {
        margin: 12,
    };

const stylePopover = {
    padding: 20,
};

class ListMasterInfo extends Component {
    UNSAFE_componentWillMount(){
        this.props.FetchListMasterParam(this.props.params._id);
    }
    renderListMaster(){
        if(this.props.listmaster.data){
            return (
                <table style={styleTable}>
                    <tbody>
                        <tr>
                            <td colSpan='3'>
                                <h1 style={{textAlign: 'center', fontWeight: 400}}> {this.props.listmaster.data.alias} </h1>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Descripción</strong></td>
                            <td colSpan='2'>{this.props.listmaster.data.description}</td>
                        </tr>
                        <tr>
                            <td colSpan='3'>
                                <div>
                                    <h1 style={{textAlign: 'center', fontWeight: 400}}>Empleados</h1>
                                    <FloatingActionButton secondary={true} style={style}>
                                        <ContentAdd />
                                    </FloatingActionButton>
                                </div>
                                <Table>
                                    <TableHeader>
                                        <TableRow>
                                            <TableHeaderColumn>Nombre</TableHeaderColumn>
                                            <TableHeaderColumn>Clave</TableHeaderColumn>
                                            <TableHeaderColumn>valor</TableHeaderColumn>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {this.renderList(this.props.listmaster.data.sources)}
                                    </TableBody>
                                </Table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            );
        }
    }
    renderList(sources){
        return sources.map((source) => {
            return (
                <TableRow key={source._id}>
                    <TableRowColumn>{source.name}</TableRowColumn>
                    <TableRowColumn>{source.key}</TableRowColumn>
                    <TableRowColumn>{source.value}</TableRowColumn>
                </TableRow>
            );
        });
    }
    render() {
        return (
          <Row>
              <Col xsOffset={2} xs={8}>
                  <Paper style={stylePaper}>
                      <Row>
                          <Col xs>
                              {this.renderListMaster()}
                          </Col>
                      </Row>
                  </Paper>
              </Col>
          </Row>
        );
    }
}

function mapStateToProps(state){
    return  { listmaster: state.listmaster.all };
}

export default connect (mapStateToProps, { FetchListMasterParam })(ListMasterInfo);
